import React from 'react';
import { Alert } from 'antd';

export default class PaymentError extends React.Component {
	componentDidMount() {
		if (window.location.href.indexOf('clearCart') !== -1) {
			localStorage.removeItem('fieldProgramCart');
		}
	}
	render() {
		return (
			<Alert showIcon
				type="error"
				message="Whoops!"
				description={
					<span>
						Your payment has been processed but didn't quite make it into our system. You are still registered for your programs, but you may have an (incorrect) outstanding balance on your account.
						<br /><br />
				 		Please contact <a href="mailto:techsupport@semesteratsea.org">techsupport@semesteratsea.org</a> and/or <a href="mailto:field@isevoyages.org">field@isevoyages.org</a>
				 	</span>
				 } />
		);
	}
}


// WEBPACK FOOTER //
// ./portal-components/Portal/PaymentError/index.jsx